import { render, staticRenderFns } from "./DeckCardHero.vue?vue&type=template&id=504a36f4&"
import script from "./DeckCardHero.vue?vue&type=script&lang=js&"
export * from "./DeckCardHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports